export const getAmountDaysLeft = (subscriptionEndDate: Date) => {
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate)
  return Math.ceil((endDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
}